import type { UiLocale } from "@lib/locale";

export const DEFAULT_COURSE_SLUG = "portuguese-from-english";
export const DEFAULT_TARGET_LOCALE: UiLocale = "pt-BR";
export const DEFAULT_NATIVE_LOCALE: UiLocale = "en";

/** The language pair a generation prompt is written for. */
export type CourseLanguageConfig = {
  targetLocale: string;
  nativeLocale: string;
};

/**
 * Used when a caller does not name a course - both prompt builders defaulted to
 * this. Frozen because it is now one shared object rather than a fresh literal
 * per call: nothing mutates it today, and nothing may start.
 */
export const DEFAULT_COURSE_LANGUAGE: CourseLanguageConfig = Object.freeze({
  targetLocale: DEFAULT_TARGET_LOCALE,
  nativeLocale: DEFAULT_NATIVE_LOCALE,
});
